export default function exportFile(data, url) {
    let form = document.createElement("form");

    for (let key in data) {
        let dom = document.createElement("input");
        dom.setAttribute("name", key);
        dom.setAttribute("value", data[key]);
        form.appendChild(dom);
    }

    form.setAttribute("style", "display:none");
    form.setAttribute("target", "");
    form.setAttribute("method", "post");

    form.setAttribute("action", url)

    document.body.appendChild(form);
    form.submit();
}